/* /auth/magic?t=TOKEN&to=/dashboard — single-click login.
   Reads a JWT from the URL, stores it in localStorage, redirects.
   Avoids the keyboard / autofill / browser-saved-password problem entirely. */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function MagicLoginPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const token = params.get("t");
    const to = params.get("to") || "/dashboard";
    if (!token) { nav("/login", { replace: true }); return; }
    try {
      localStorage.setItem("faitharama_token", token);
      // Soft refresh so AuthContext picks up the token
      window.location.replace(to);
    } catch (e) {
      nav("/login", { replace: true });
    }
  }, [params, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="magic-login">
      <div className="text-center">
        <div className="text-2xl font-bold mb-2" style={{ color: "#2E9F3A" }}>Signing you in…</div>
        <div className="text-sm text-gray-500">If this hangs more than 5 seconds, click <a href="/dashboard" className="underline font-bold" style={{ color: "#2E9F3A" }}>here</a>.</div>
      </div>
    </div>
  );
}
